// import styles from 'dom-helpers/style';
import { styled } from 'css-literal-loader/styled';
import React from 'react';
import Dropdown from 'react-overlays/Dropdown';
// import PopperUtils from 'popper.js/dist/popper-utils';

// function positionToSelected(acc, { contentAnchor }) {
//   const { popper } = acc.instance;
//   const contentNode = popper.querySelector(contentAnchor);

//   if (!contentNode || !popper.dataset.show) return acc;

//   const offsets = PopperUtils.getOffsetRectRelativeToArbitraryNode(
//     contentNode,
//     popper,
//     acc.positionFixed,
//   );

//   acc.offsets.popper.top -= offsets.top;
//   acc.offsets.popper.left -= parseInt(styles(contentNode, 'padding-left'), 10);

//   acc.styles.transformOrigin = `${offsets.left}px ${offsets.bottom}px`;

//   return acc;
// }

const StyledDropdownMenu = styled('div', null, "StyledDropdownMenu", require("./DropdownMenu-StyledDropdownMenu.module.scss"), "styled-dropdown-menu", "styledDropdownMenu");

const popperConfig = {
  modifiers: {
    offset: {
      enabled: true,
      offset: '-12px, -50%p - 12px',
    },
    preventOverflow: {
      padding: 20,
    },
    // positionToSelected: {
    //   enabled: true,
    //   contentAnchor: '[data-selected=true]',
    //   padding: 5,
    //   boundariesElement: 'viewport',
    //   fn: positionToSelected,
    // },
    computeStyle: {
      gpuAcceleration: false,
    },
    applyTransition: {
      enabled: true,
      order: 860,
      fn(acc) {
        acc.styles.willChange += ', transform';
        acc.instance.popper.dataset.popper = true;
        return acc;
      },
    },
  },
};

export default function DropdownMenu({ children }) {
  return (
    <Dropdown.Menu popperConfig={popperConfig}>
      {({ show, close, props }) => (
        <StyledDropdownMenu
          {...props}
          show={show}
          onClick={close}
          data-show={show}
          role="menu"
        >
          {children}
        </StyledDropdownMenu>
      )}
    </Dropdown.Menu>
  );
}
